import { ToolImplementation, ToolResult, ToolSchema } from '../tool-types';

const DEFAULT_QR_TEXT = 'Probefahrt buchen';
const DEFAULT_QR_URL = 'https://www.cupraofficial.de/kontakt/probefahrt';
const DEFAULT_QR_DURATION_MS = 20000;

export const qrCodeToolCupraSchema: ToolSchema = {
  type: 'function',
  name: 'show_qr_code',
  description:
    'Display a QR code in the frontend for test-drive lead capture. Use this when user agrees to book a test drive.',
  parameters: {
    type: 'object',
    properties: {
      text: {
        type: 'string',
        description: 'Label text shown with the QR code'
      },
      url: {
        type: 'string',
        description: 'URL encoded in the QR code'
      },
      durationMs: {
        type: 'number',
        description: 'Optional display duration in milliseconds'
      }
    },
    required: [],
    additionalProperties: false
  }
};

export const qrCodeToolCupraImplementation: ToolImplementation = async (
  args: any
): Promise<ToolResult> => {
  try {
    const text = typeof args?.text === 'string' && args.text.trim() ? args.text.trim() : DEFAULT_QR_TEXT;
    const url = typeof args?.url === 'string' && args.url.trim() ? args.url.trim() : DEFAULT_QR_URL;
    const durationMs =
      typeof args?.durationMs === 'number' && Number.isFinite(args.durationMs) && args.durationMs > 0
        ? args.durationMs
        : DEFAULT_QR_DURATION_MS;

    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('cupra-show-qr', {
          detail: { text, url, durationMs }
        })
      );
    }

    return {
      success: true,
      data: `QR code requested for ${url} (duration: ${durationMs}ms).`
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error while requesting QR code display'
    };
  }
};

